import dynamic from 'next/dynamic';

export const NumberFormat = dynamic(() => import('react-number-format'));
export default NumberFormat;
